import InputValidationStateBo from "../../../../../form/input/InputValidationStateBo";
import InputValidator from "../../../../../form/input/InputValidator";
import InputValidatorI from "../../../../../form/input/InputValidatorI";

export default class HundeVersicherbarValidator implements InputValidatorI {

    private versicherbar?: boolean;

    constructor(newValue?: boolean) {
        this.versicherbar = newValue;
    }

    validate() {
        if (InputValidator.isBooleanTrue(this.versicherbar)) {
            return InputValidationStateBo.createValid();
        }

        return InputValidationStateBo.createInValid("Aufgrund Ihrer Angaben ist ein Angebot nicht möglich.");
    }

}